import { SITE_DESCRIPTION, SITE_NAME } from './seo'

/**
 * Facts about the hotel used for schema.org markup. Fields marked "to confirm"
 * are deliberately left empty until the hotel confirms them: structured data is
 * read by search engines and AI assistants as fact, so nothing is guessed here.
 */
export const HOTEL = {
  name: SITE_NAME,
  description: SITE_DESCRIPTION,
  telephone: '+48327462800',
  email: 'recepcja@poziom511.com',
  priceRange: '$$$',
  address: {
    streetAddress: 'Bonerów 33',
    addressLocality: 'Podzamcze',
    addressRegion: 'Śląskie',
    postalCode: '42-440',
    addressCountry: 'PL',
  },
  geo: { latitude: 50.450_771_3, longitude: 19.553_020_4 },
  sameAs: [
    'https://www.facebook.com/poziom511/',
    'https://www.instagram.com/poziom511/',
  ],
  /** Google Maps, Booking, Tripadvisor: append here once confirmed. */
  extraProfiles: [] as string[],
  /** `{ name: 'Basen z wodą źródlaną' }` etc. (to confirm) */
  amenities: [] as { name: string }[],
  /** `'Perfect SPA Awards 2025 - najlepszy hotel SPA'` etc. (to confirm) */
  awards: [] as string[],
  /** `'15:00'` (to confirm) */
  checkinTime: undefined as string | undefined,
  /** `'11:00'` (to confirm) */
  checkoutTime: undefined as string | undefined,
  petsAllowed: undefined as boolean | undefined,
  numberOfRooms: undefined as number | undefined,
  availableLanguage: undefined as string[] | undefined,
} as const

export const RESTAURANT = {
  name: 'Restauracja & Bar 511',
  path: 'restauracja',
  /** `'polska, regionalna'` (to confirm) */
  servesCuisine: undefined as string | undefined,
  /** Absolute URL of the menu (to confirm) */
  menu: undefined as string | undefined,
  /** schema.org openingHoursSpecification entries (to confirm) */
  openingHoursSpecification: undefined as Record<string, unknown>[] | undefined,
} as const

export const WINERY = {
  name: 'Winnica Białe Skały',
  path: 'winnica',
} as const
